import React from 'react';

import { ShareableAttributeInput } from './shareable_attribute_input';
import { getShareableAttributes } from './shareable_attributes';

import type { Contact } from 'bundles/backoffice/contacts/types';

interface Props {
  contact: Contact;
  sharedAttributes: string[];
  onChange: (attributes: string[]) => void;
}

export function ShareableAttributesForm({ contact, sharedAttributes, onChange }: Props) {
  return (
    <div>
      <p>
        This will create a shared version of {contact.name} that other users will be able to see.
        What details would you like to include on this shared version?
      </p>

      {getShareableAttributes(contact).map(attribute => (
        <ShareableAttributeInput
          attribute={attribute}
          key={attribute.key}
          sharedAttributes={sharedAttributes}
          onChange={onChange}
        />
      ))}
    </div>
  );
}
